import { useState } from 'react';
import type { ServerLogEntry } from '@/shared/types/api';
import { LogRow } from './LogRow';

interface LogTableProps {
  items: ServerLogEntry[];
  onShowTrace: (traceId: string, timestamp?: string) => void;
}

const th = 'px-3 py-2.5 text-xs font-medium uppercase tracking-wider text-muted-foreground';

export function LogTable({ items, onShowTrace }: LogTableProps) {
  const [expanded, setExpanded] = useState<ReadonlySet<string>>(new Set());

  const toggle = (id: string) =>
    setExpanded((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });

  return (
    <div className="card overflow-hidden p-0">
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-border text-left">
          <thead>
            <tr className="bg-muted/50">
              <th className="w-8 py-2.5 pl-2 pr-0">
                <span className="sr-only">Details</span>
              </th>
              <th className={th}>Time</th>
              <th className={th}>Level</th>
              <th className={th}>Source</th>
              <th className={th}>Message</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {items.map((entry) => (
              <LogRow
                key={entry.id}
                entry={entry}
                expanded={expanded.has(entry.id)}
                onToggle={() => toggle(entry.id)}
                onShowTrace={onShowTrace}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
